export default () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6101 8.41005C17.1568 7.86332 18.0432 7.86332 18.5899 8.41005C19.1367 8.95678 19.1367 9.84322 18.5899 10.39L12.9899 15.99C12.4432 16.5367 11.5568 16.5367 11.0101 15.99L5.41005 10.39C4.86332 9.84322 4.86332 8.95678 5.41005 8.41005C5.95678 7.86332 6.84322 7.86332 7.38995 8.41005L12 13.0201L16.6101 8.41005Z"
      fill="currentColor"
    />
  </svg>
);
